<div class="container">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">

      <div class="auth-box">

        <div class="logo-above-auth-box logo-tenant-as-background"></div>

        <!-- content -->
        <div class="auth-box-content-wrapper">

          <div *ngIf="verifyEmailWorking">
            <p>{{ 'verify-email.in-progress' | translate }}</p>

            <div class="progress">
              <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%;margin-bottom:30px;"></div>
            </div>
            
          </div>

          <div *ngIf="hasError" >
            <div class="alert alert-warning">
              <p><strong>{{ errorMessage | translate }}</strong></p>
            </div>
            <button class="btn btn-success" routerLink="/login">
              {{ 'activate.to-login' | translate }}
            </button>
          </div>

          <div *ngIf="!verifyEmailWorking && verifyEmailSuccess">
          <div class="alert alert-success">
            <p><strong>{{ 'verify-email.verified' | translate }}</strong></p>
          </div>

            <div *ngIf="!accountValidationNeeded">
              <p>
                {{ 'activate.account-activated' | translate }}
              </p>
              <button class="btn btn-success" routerLink="/login">
                {{ 'activate.to-login' | translate }}
              </button>
            </div>

            <div *ngIf="accountValidationNeeded">
              <p>
                {{ 'activate.account-validation-needed' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
